<template>
  <div id="footer-basic">
    <footer
      class="footer text-white bg-color-primary py-2"
      :style="{'background-color': `${currentScopedCompanyPage.secondary_color}` + ' !important'}"
    >
      <div class="container">
        <a href="https://abler.com.br">
          <p class="small text-center m-0">
            Feito com
            <i class="fa fa-heart" aria-hidden="true" />
            pelo Abler
          </p>
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mixins from '../mixins/mixins';

export default {
  name: 'FooterBasic',
  mixins: [mixins],
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
      'currentScopedCompanyPage',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
    ]),
  },
};
</script>
